/**
 * Indicates if a way is open ticket (true/false), if way is not valid it will return null
 * @param {*} way
 * @returns {boolean|null}
 */
export default function wayIsOpenTicket(way) {
  if (!way || !way.fragments || way.fragments.length === 0) return null;
  const [fragment] = way.fragments;
  return fragment.trip.openTicket;
}

/**
 * Checks if a trip is hybrid, A hybrid trip is when one of the trips is open ticket and the other is normal
 * @param {Object} departs - departure object from the purchase state
 * @param {*} returns - return object from the purchase state
 * @returns {boolean} true if the trip is hybrid (one leg is open ticket and the other is normal), otherwise false
 */
export function isHybridTrip(departs, returns) {
  const isDepartureOpen = wayIsOpenTicket(departs);
  const isReturnOpen = wayIsOpenTicket(returns);
  // `wayIsOpenTicket` returns null for missing/empty ways, so this stays
  // consistent with it (an empty `fragments` array is not a valid return way).
  const hasValidReturn = isReturnOpen !== null;
  return (
    (isDepartureOpen && !isReturnOpen && hasValidReturn) ||
    (!isDepartureOpen && isReturnOpen && hasValidReturn)
  );
}
